"use client";
import { observer } from "../../service/mobx";
import { useTrackView } from "../../component/Hooks";

function Hooks() {
  useTrackView("API");
}

export default observer(Hooks);
